// generated with @7nohe/openapi-react-query-codegen@1.6.2
import { ConfigurationService } from "../requests/services.gen";

import { UseQueryResult } from "@tanstack/react-query";

export type ConfigurationServiceGetCustomApiConfigurationCfgIonLineNewDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationCfgIonLineNew
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationCfgIonLineNewQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationCfgIonLineNewDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationCfgIonLineNewKey =
  "ConfigurationServiceGetCustomApiConfigurationCfgIonLineNew";
export const UseConfigurationServiceGetCustomApiConfigurationCfgIonLineNewKeyFn =
  (
    {
      currencyId,
      fhIdent,
      localeId,
      sortiment,
    }: {
      currencyId?: string | undefined;
      fhIdent?: string | undefined;
      localeId?: string | undefined;
      sortiment?: string | undefined;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useConfigurationServiceGetCustomApiConfigurationCfgIonLineNewKey,
    ...(queryKey ?? [{ currencyId, fhIdent, localeId, sortiment }]),
  ];
export type ConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationDocumentBySessionIdPdf
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfKey =
  "ConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdf";
export const UseConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfKeyFn =
  (
    {
      localeId,
      sessionId,
    }: {
      localeId?: string | undefined;
      sessionId: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfKey,
    ...(queryKey ?? [{ localeId, sessionId }]),
  ];
export type ConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationFachhaendlerByFhIdent
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentKey =
  "ConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdent";
export const UseConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentKeyFn =
  (
    {
      country,
      fhIdent,
      lang,
    }: {
      country?: string | undefined;
      fhIdent: string;
      lang?: string | undefined;
    },
    queryKey?: Array<unknown>,
  ) => [
    useConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentKey,
    ...(queryKey ?? [{ country, fhIdent, lang }]),
  ];
export type ConfigurationServiceGetCustomApiConfigurationInfoDefaultResponse =
  Awaited<
    ReturnType<typeof ConfigurationService.getCustomApiConfigurationInfo>
  >;
export type ConfigurationServiceGetCustomApiConfigurationInfoQueryResult<
  TData = ConfigurationServiceGetCustomApiConfigurationInfoDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationInfoKey =
  "ConfigurationServiceGetCustomApiConfigurationInfo";
export const UseConfigurationServiceGetCustomApiConfigurationInfoKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useConfigurationServiceGetCustomApiConfigurationInfoKey,
  ...(queryKey ?? []),
];
export type ConfigurationServiceGetCustomApiHelloWorldDefaultResponse = Awaited<
  ReturnType<typeof ConfigurationService.getCustomApiHelloWorld>
>;
export type ConfigurationServiceGetCustomApiHelloWorldQueryResult<
  TData = ConfigurationServiceGetCustomApiHelloWorldDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiHelloWorldKey =
  "ConfigurationServiceGetCustomApiHelloWorld";
export const UseConfigurationServiceGetCustomApiHelloWorldKeyFn = (
  queryKey?: Array<unknown>,
) => [useConfigurationServiceGetCustomApiHelloWorldKey, ...(queryKey ?? [])];
export type ConfigurationServicePostCustomApiConfigurationMailMutationResult =
  Awaited<
    ReturnType<typeof ConfigurationService.postCustomApiConfigurationMail>
  >;
